<template>
  <header class="hdr">
    <div class="inner">
      <button class="brand" :aria-label="hotelName || 'Seth Hotels'" @click="navigateLanding(false)">
        <img :src="logo" :alt="hotelName || 'Seth Hotels'" class="logo" />
      </button>

      <div v-if="store.idiomas.length" data-rail class="langs">
        <button
          v-for="l in store.idiomas"
          :key="l.locale"
          class="lang"
          :class="{ active: l.locale === store.locale }"
          :title="l.nombre"
          @click="setLocale(l.locale)"
        >
          <img v-if="l.bandera" :src="l.bandera" :alt="l.nombre" class="flag" loading="lazy" />
          <span>{{ l.locale.toUpperCase() }}</span>
        </button>
      </div>

      <button class="mine-btn" :class="{ active: store.view === 'mine' }" @click="toggleView">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M20 21a8 8 0 0 0-16 0" /><circle cx="12" cy="7" r="4" /></svg>
        <span>{{ ui.mis }}</span>
        <span v-if="store.mine.length" class="count">{{ store.mine.length }}</span>
      </button>
    </div>
  </header>
</template>

<script>
import { UI } from '@/data'
import { store, setLocale, toggleView, navigateLanding } from '@/store'
import logo from '@/assets/seth-logo.png'

export default {
  name: 'AppHeader',
  props: {
    hotelName: { type: String, default: '' }
  },
  data() {
    return { store, logo }
  },
  computed: {
    ui() { return UI[store.locale] || UI.es }
  },
  methods: { setLocale, toggleView, navigateLanding }
}
</script>

<style scoped>
.hdr {
  position: sticky;
  top: 0;
  z-index: 30;
  background: rgba(255, 255, 255, 0.92);
  backdrop-filter: blur(10px);
  border-bottom: 1px solid var(--sand-200);
}
.inner {
  max-width: 1180px;
  margin: 0 auto;
  padding: 12px clamp(16px, 4vw, 40px);
  display: flex;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
}
.brand {
  display: flex;
  align-items: center;
  margin-right: auto;
  padding: 0;
  border: none;
  background: transparent;
  cursor: pointer;
}
.logo { height: 38px; width: auto; display: block; }

.langs {
  display: flex;
  gap: 4px;
  background: var(--sand-100);
  padding: 4px;
  border-radius: var(--radius-pill);
  overflow: auto;
  max-width: 100%;
}
.lang {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  border: none;
  cursor: pointer;
  padding: 6px 12px;
  border-radius: 999px;
  font-family: var(--font-sans);
  font-weight: 700;
  font-size: 0.78rem;
  letter-spacing: 0.04em;
  transition: all 160ms;
  background: transparent;
  color: var(--ink-500);
  white-space: nowrap;
}
.flag {
  width: 18px;
  height: 13px;
  border-radius: 2px;
  object-fit: cover;
  display: block;
  flex-shrink: 0;
}
.lang.active { background: var(--seth-navy); color: #fff; }

.mine-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 9px 16px;
  border-radius: 999px;
  cursor: pointer;
  font-family: var(--font-sans);
  font-weight: 600;
  font-size: 0.9rem;
  transition: all 180ms;
  background: #fff;
  color: var(--seth-navy);
  border: 1px solid var(--sand-300);
}
.mine-btn.active { background: var(--seth-navy); color: #fff; border-color: var(--seth-navy); }
.count {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 20px;
  height: 20px;
  padding: 0 5px;
  border-radius: 999px;
  background: var(--seth-gold);
  color: var(--seth-navy);
  font-size: 0.72rem;
  font-weight: 700;
}
</style>
